import { Button, HStack, NativeSelect, Text, VStack } from '@chakra-ui/react'
import { Header } from '@hivemq/ui-library'
import { SettingsIcon } from 'lucide-react'
import { type FC, useId } from 'react'
import { useTranslation } from 'react-i18next'
import { ColorModeIcon, useColorMode } from '../ui/colorMode'

export function SettingsToolbar() {
  const { t } = useTranslation()

  const { toggleColorMode } = useColorMode()

  return (
    <Header.Menu overlayId="user_settings">
      <Header.MenuButton
        aria-label={t('panel.settings.title')}
        icon={SettingsIcon}
      />

      <Header.MenuContent>
        <Header.MenuContentDetails textAlign="center">
          <Text fontSize="1.2rem">{t('panel.settings.title')}</Text>
        </Header.MenuContentDetails>

        <SelectLanguage />
        <Header.MenuContentDetails asChild>
          <Button
            data-testid="logout-button"
            variant="plain"
            fontSize="md"
            color="white"
            onClick={toggleColorMode}
            w="100%"
            my={2}
          >
            <HStack w="100%" justifyContent="space-between">
              <span>{t('panel.settings.colorMode')}</span>
              <ColorModeIcon />
            </HStack>
          </Button>
        </Header.MenuContentDetails>
      </Header.MenuContent>
    </Header.Menu>
  )
}

const availableLanguages = [
  { code: 'en', name: 'English' },
  { code: 'de', name: 'Deutsch' },
  { code: 'fr', name: 'Français' },
] as const

const SelectLanguage: FC = () => {
  const { t, i18n } = useTranslation()

  // Get the current language, fallback to 'en' if not found
  const currentLanguage =
    availableLanguages.find((lang) => lang.code === i18n.language)?.code || 'en'

  const languageInputId = useId()
  return (
    <Header.MenuContentDetails>
      <VStack w="100%" justifyContent="space-between" alignItems="flex-start">
        <label htmlFor={languageInputId}>{t('panel.settings.language')}</label>
        <NativeSelect.Root>
          <NativeSelect.Field
            fontSize="md"
            id={languageInputId}
            value={currentLanguage}
            onChange={(e) => {
              i18n.changeLanguage(e.currentTarget.value)
            }}
          >
            {availableLanguages.map((lang) => (
              <option key={lang.code} value={lang.code}>
                {lang.name}
              </option>
            ))}
          </NativeSelect.Field>
          <NativeSelect.Indicator />
        </NativeSelect.Root>
      </VStack>
    </Header.MenuContentDetails>
  )
}
